export var IMAGES_WIDTH = {
    MOBILE: 360,
    DESKTOP_BANNER: 1920,
};
export var DimensionsToWidth = {
    '1x1': 240,
    '1x2': 280,
    '2x1': 600,
    '2x2': 600,
};
export var DimensionsToAspectRatio = {
    '1x1': 1.0,
    '1x2': 2.0,
    '2x1': 0.5,
    '2x2': 1.0,
};
export var DeliveryPromise = {
    Valentines: 'event_delivery_promise_valentines_day',
};
